(function () {
	'use strict';
	angular.module('app.core')
		.service('itemDetailsService', itemDetailsService);

	itemDetailsService.$inject = ['$http', '$q', 'URLS', 'itemDetailsPendingRequestsService', 'storeService'];

	function itemDetailsService($http, $q, URLS, itemDetailsPendingRequestsService, storeService) {
		function getMultiproject(itemCode, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/ItemDrilldownMultiproject?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(function (response) {
					itemDetailsPendingRequestsService.removeRequest(url);
					return response.status === 204 || !response.data ? { data: [] } : response.data;
				})
				.catch(function (error) {
					itemDetailsPendingRequestsService.removeRequest(url);
					return { data: [] };
				});
		}

		function getItemMetrics(itemId, siteId, startTimestamp, endTimestamp) {
			var url = URLS.prefix + siteId + '/ItemId/' + itemId + '/MetricValues';

			if (startTimestamp) {
				if (endTimestamp) {
					url += '?startTimestamp=' + startTimestamp + '&endTimestamp=' + endTimestamp;
				} else {
					url += '?startTimestamp=' + startTimestamp;
				}
			} else if (endTimestamp) {
				url += '?endTimestamp=' + endTimestamp;
			}
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getItemMetricsSuccess)
				.catch(getItemMetricsFailed);

			function getItemMetricsSuccess(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getItemMetricsFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return [];
			}
		}

		function getShortageData(itemId, siteId) {
			var url = URLS.prefix + siteId + '/RootCauseDateForCurrentShortage?itemId=' + itemId;
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getShortageDataSuccess)
				.catch(getShortageDataFailed);

			function getShortageDataSuccess(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getShortageDataFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return undefined;
			}
		}

		function getActualPo(itemCode, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/ItemDrilldownActualPoDeliveries?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getActualPoComplete)
				.catch(getActualPoFailed);

			function getActualPoComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getActualPoFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return undefined;
			}
		}

		function getHistorical(itemCode, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/ItemDrilldownHistoricalPurchaseData?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getHistoricalComplete)
				.catch(getHistoricalFailed);

			function getHistoricalComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getHistoricalFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return undefined;
			}
		}

		function getManufacturedHistorical(itemCode, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/ItemDrilldownHistoricalManufacturedData?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getManufacturedHistoricalComplete)
				.catch(getManufacturedHistoricalFailed);

			function getManufacturedHistoricalComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getManufacturedHistoricalFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return undefined;
			}
		}

		function getMultitenant(itemCode, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/ItemDrilldownMultitenant?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getMultitenantComplete)
				.catch(getMultitenantFailed);

			function getMultitenantComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getMultitenantFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return undefined;
			}
		}

		function convertLegacyItemData(response) {
			var itemData = response[0];
			if (itemData) {
				// convert some of field names to the way they appear in itemReport
				itemData.factoryNdx = itemData.ldfNdx;
				itemData.analysisExcessOnHandOverLTQty = itemData.excessOverLtMultiple;
				if (itemData.itemType === 'Manufactured') {
					// Manufactured item that is not in itemreport, so we have very limited information on it
					itemData.detailType = 'basic';
				}
				// In legacy call, the safety stock total is split between two fields
				itemData.safetyStockTotal = itemData.safetyStockFloat + itemData.safetyStockBasedOnTime;
			}
			return itemData;
		}

		function getItemMasterData(itemCode, procureRptNdx, specificFields, itemType, factoryNdx) {
			// itemCode is sent hex-encoded to avoid CloudFront WAF SQLi rules
			// flagging itemCodes that contain `--`. The server hex-decodes the
			// itemCode query param. See ApiUtils.hexToString.
			var url = URLS.prefix + factoryNdx + '/SupplyChain/Item?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getItemMasterDataComplete)
				.catch(getItemMasterDataFailed);
			
			// Convert the input value given the input factor. Then format the result: it'll have a minimum of 2 decimals. 
			// If the original number had more than 2 decimals, the converted result will have the same number of decimals 
			// as the original number.
			function convertAndFormatCurrencyField(value, conversionFactor) {
				var convertedValue = value / conversionFactor;
				var newNumOfDecimals = numberOfDecimals(value, 2, true);
				newNumOfDecimals = Math.max(newNumOfDecimals, 2);
				return Number(convertedValue.toFixed(newNumOfDecimals));
			}

			function convertItemFlexCurrencyFields(itemData, conversionFactor) {
				_.each(globalConfig.customer.flexFields, function (field, fieldName) {
					if (field.sourceType === 'item' && field.storageType === 'currency') {
						itemData[fieldName] = convertAndFormatCurrencyField(itemData[fieldName], conversionFactor);
					}
				});
			}

			function getItemMasterDataComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				// Massage the response from itemReport to match some of the naming conventions in the frontend
				response.data.detailType = 'full';
				if (typeof response.data.analysisAvgDailyDemandFloat === 'undefined') {
					response.data.detailType = 'basic';
				}
				response.data.code = response.data.fullItemCode;
				response.data.itemCodeDisplay = response.data.itemCode;
				response.data.itemCode = response.data.fullItemCode;
				response.data.description = response.data.itemDescription;
				response.data.alias = response.data.itemAlias;
				response.data.reorderPointFloat = response.data.reOrderPointFloat;
				response.data.uom = response.data.itemUOM;
				// In itemReport, the safetyStockFloat field is the total of qty and time based safety stock
				response.data.safetyStockTotal = response.data.safetyStockFloat;
				response.data.safetyStockFloat = response.data.safetyStockWithoutTime;
				
				// Convert currency fields
				if (response.data.conversionFactorUsed && response.data.conversionFactorUsed !== 1) {
					response.data.analysisAverageDailyCostFloat /= response.data.conversionFactorUsed;
					response.data.analysisExcessOnHandOverLTValue /= response.data.conversionFactorUsed;
					response.data.analysisExcessOnOrderOverLTValue /= response.data.conversionFactorUsed;
					response.data.costPerItemFloat = convertAndFormatCurrencyField(response.data.costPerItemFloat, response.data.conversionFactorUsed);
					response.data.currentOnHandCostFloat /= response.data.conversionFactorUsed;
					response.data.currentVsPotential /= response.data.conversionFactorUsed;
					response.data.deltaWeeklyExcessOnHandValue /= response.data.conversionFactorUsed;
					response.data.deltaWeeklyExcessOnOrderValue /= response.data.conversionFactorUsed;
					response.data.excessOnHandValue /= response.data.conversionFactorUsed;
					response.data.excessOnOrderDemandedValue /= response.data.conversionFactorUsed;
					response.data.excessOnOrderObsoleteValue /= response.data.conversionFactorUsed;
					response.data.excessOnOrderValue /= response.data.conversionFactorUsed;
					response.data.excessOnOrderValuePositive /= response.data.conversionFactorUsed;
					response.data.excessOnhandDemandedValue /= response.data.conversionFactorUsed;
					response.data.excessOnhandObsoleteValue /= response.data.conversionFactorUsed;
					response.data.excessOnhandOverLTValue /= response.data.conversionFactorUsed;
					response.data.excessOnhandValuePositive /= response.data.conversionFactorUsed;
					response.data.excessAtOtherSites /= response.data.conversionFactorUsed;
					response.data.next30Days /= response.data.conversionFactorUsed;
					response.data.next60Days /= response.data.conversionFactorUsed;
					response.data.next90Days /= response.data.conversionFactorUsed;
					response.data.onhandValueGtMinMax /= response.data.conversionFactorUsed;
					response.data.onhandValueGtReorderPoint /= response.data.conversionFactorUsed;
					response.data.opportunityFloat /= response.data.conversionFactorUsed;
					response.data.pastDueRequirementValue /= response.data.conversionFactorUsed;
					response.data.potentialSavings /= response.data.conversionFactorUsed;
					response.data.projInventoryChanges /= response.data.conversionFactorUsed;
					response.data.projInventoryChangesFloat /= response.data.conversionFactorUsed;
					response.data.quotedPrice /= response.data.conversionFactorUsed;
					response.data.standardPrice /= response.data.conversionFactorUsed;
					response.data.totalOnHandValue /= response.data.conversionFactorUsed;
					response.data.totalOnOrderCostFloat /= response.data.conversionFactorUsed;
					response.data.totalOnOrderValue /= response.data.conversionFactorUsed;
					response.data.valueOverDaysOfInventoryTarget /= response.data.conversionFactorUsed;
					response.data.weeklyInventoryDelta /= response.data.conversionFactorUsed;
					response.data.weeklyOpportunityDelta /= response.data.conversionFactorUsed;
					convertItemFlexCurrencyFields(response.data, response.data.conversionFactorUsed);
				}
				return response.data;
			}

			function getItemMasterDataFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
			}
		}

		function getAlternateItems(itemCode, factoryNdx) {
			var url = URLS.prefix + factoryNdx + '/ItemDrilldownAlternateItems?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(URLS.host + url, { timeout: canceller.promise })
				.then(getAlternateItemsComplete)
				.catch(getAlternateItemsFailed);

			function getAlternateItemsComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getAlternateItemsFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return undefined;
			}
		}

		function getPoRecommendations(itemCode, factoryNdx) {
			var url = URLS.host + String.format(URLS.poRecommendations, factoryNdx) +
				'?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(url, { timeout: canceller.promise })
				.then(getPoRecommendationsComplete)
				.catch(getPoRecommendationsFailed);

			function getPoRecommendationsComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getPoRecommendationsFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return undefined;
			}
		}

		function getIAStatusedPoRecs(itemCode, factoryNdx) {
			var url = URLS.host + String.format(URLS.iaStatusedPoRecs, factoryNdx) +
				'?itemCode=' + storeService.toHex(itemCode);
			var canceller = $q.defer();
			itemDetailsPendingRequestsService.addRequest({
				url: url,
				canceller: canceller
			});
			return $http.get(url, { timeout: canceller.promise })
				.then(getIAStatusedPoRecsComplete)
				.catch(getIAStatusedPoRecsFailed);

			function getIAStatusedPoRecsComplete(response) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return response.data;
			}

			function getIAStatusedPoRecsFailed(error) {
				itemDetailsPendingRequestsService.removeRequest(url);
				return undefined;
			}
		}

		return {
			getItemMetrics: getItemMetrics,
			getItemMasterData: getItemMasterData,
			getMultitenant: getMultitenant,
			getMultiproject: getMultiproject,
			getHistorical: getHistorical,
			getActualPo: getActualPo,
			getManufacturedHistorical: getManufacturedHistorical,
			getAlternateItems: getAlternateItems,
			getShortageData: getShortageData,
			getPoRecommendations: getPoRecommendations,
			getIAStatusedPoRecs: getIAStatusedPoRecs
		};
	}
})();
